<script lang="ts">
    import FieldHeading from './field-heading.svelte'

    export let label: string
    export let data: Record<string, any>
    export let value: string = ''
    export let required = false
    export let readOnly = false
</script>

<div class="view-field">
    <FieldHeading {label} {required} {readOnly} />
    <input type="text" class="view-input" bind:value disabled={readOnly} placeholder="Sua resposta" />
</div>

<style>
    .view-input {
        width: 100%;
        max-width: 420px;
        border: none;
        border-bottom: 1px solid #ced4da;
        background: transparent;
        padding: 6px 2px;
        font-size: 0.9rem;
    }
    .view-input:focus {
        outline: none;
        border-bottom: 2px solid var(--cs2-accent, #4263eb);
    }
    .view-input:disabled {
        /* anula o !important do css_global.css (input:disabled) que pinta o fundo de cinza/escuro */
        background: transparent !important;
        color: #868e96;
        cursor: not-allowed;
    }
</style>
